<template>
  <div class="search-banner">
    <div class="search-banner-title">{{ imgTitle }}</div>
    <div class="search-bar">
      <searchBox />
    </div>
    <div class="search-banner-keywords">
      <a
        v-for="(item, ind) in searchInfo.search_tags"
        :key="ind"
        @click="onKey(item.name)"
        >{{ item.name }}</a
      >
    </div>
    <div class="search-banner-bg">
      <img v-if="imgPath" v-lazy="imgPath" />
    </div>
  </div>
</template>

<script lang="ts">
import router from "@/router";
import { MutationTypes, useStore } from "@/store";
import { computed, defineComponent, reactive, ref, toRefs } from "vue";
import searchBox from "@/components/searchBox.vue";
import { CommonService } from "@/api/common";

export default defineComponent({
  name: "SearchBanner",
  components: {
    searchBox,
  },
  setup() {
    const store = useStore();
    const search = computed(() => store.state.seachKey);
    const imgPath = ref("");
    const imgTitle = ref("搜索你喜欢的设计");
    const searchKey = reactive({
      keyValue: search.value,
    });
    const onSearch = () => {
      router.push("/templates/FL0");
      store.commit(MutationTypes.SET_SEARCH_KEY, searchKey.keyValue);
    };
    const searchInfo = ref([]);
    const getIndexSearchInfo = async () => {
      const params = {};
      const res = await CommonService.getIndexSearchInfo(params);
      searchInfo.value = res.data.data;
      imgPath.value = res.data.data.ad[0].imgUrl;
      imgTitle.value = res.data.data.ad[0].title;
    };
    getIndexSearchInfo();
    const onKey = (name: string) => {
      searchKey.keyValue = name;
      onSearch();
    };
    return {
      ...toRefs(searchKey),
      onSearch,
      onKey,
      imgPath,
      imgTitle,
      searchInfo,
    };
  },
});
</script>

<style lang="scss">
.search-banner {
  position: relative;
  margin-top: 20px;
  .search-banner-title {
    position: absolute;
    z-index: 999;
    top: 74px;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    width: 35%;
    font-size: 36px;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 24px;
    text-align: center;
    color: #fff;
    min-width: 1000px;
  }
  .search-banner-keywords {
    min-width: 1000px;
    position: absolute;
    z-index: 1;
    top: 176px;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    width: 35%;
    font-size: inherit;
    line-height: 40px;
    margin-bottom: 24px;
    text-align: center;
    color: #fff;
    a {
      color: inherit;
      margin: 0 10px;
    }
    a:hover {
      font-weight: bold;
    }
  }
  .search-bar {
    position: absolute;
    z-index: 999;
    top: 136px;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    width: 500px;
  }
  .search-banner-bg {
    background: #fff;
    height: 240px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 240px;
      object-fit: cover;
      object-position: center center;
    }
  }
}
</style>
